<template>
<div>
  <!-- <dao></dao> -->
  <div class="img">
    <img src="../../assets/12.jpg" alt="">
  </div>
  <div class="zou"  >
    <div class="han">走进加农正和</div>
    <div class="ying">Enter  CANZOHO</div>
  </div>
</div>
</template>

<script>
  // import Dao from "../common/Dao"
  import {getAboutList} from "../../api/index"

  export default {
    name: "ChanYe",
    components:{
      // Dao
    },
    data(){
      return{
        data:[]
      }
    },
    mounted() {
      getAboutList().then(res=>{
        // console.log(res.data);
        let data = res.data;
        this.data = data;
      })

    }
  };
</script>

<style lang="less" scoped>
  a:hover {
    color: #1EA364;

  }
  .img img{
    width: 100%;
    height: 48.6891vh;
  }
  .zou{
    width: 11.1979vw;
    height: 13.9551vh;
    opacity: 0.8;
    background-color: #1EA364;
    position: absolute;
    margin-left: 5.5625vw;
    margin-top: -9.2vh;
  }
  .han{
    width: 10.7083vw;
    height: 1.4063vw;
    font-size: 1.5625vw;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 700;
    text-align: left;
    color: #ffffff;
    margin-top:0.771vw ;
    margin-left: 1vw;
  }
  .ying{
    width: 10.8125vw;
    height: 1.3979vw;
    font-size: 1.46vw;
    font-family: PingFang SC, PingFang SC-Light;
    font-weight: 300;
    text-align: left;
    color: #ffffff;
    margin-left: 1vw;
    margin-top: 0.7vw;
  }
</style>
